import { mapGetters } from 'vuex'
import store from '@/store'

/**
 * 映射字典数据，自动加载
 * @param {String} namespace - Vuex模块命名空间
 * @param {Array} dictionaries - 字典名称数组
 * @returns {Object} - 计算属性对象
 */
export function mapDictionaries(namespace, dictionaries) {
	// 创建getter映射
	const gettersMap = mapGetters(namespace, dictionaries)

	// 为每个getter添加自动加载功能
	const result = {}
	dictionaries.forEach(dict => {
		const originalGetter = gettersMap[dict]

		result[dict] = function() {
			const value = originalGetter.call(this)

			// 如果字典为空，自动触发加载
			if (!value || value.length === 0) {
				// 构造action名称，例如：certTypeDict -> getCertTypeDictList
				// const actionName = `get${dict.charAt(0).toUpperCase() + dict.slice(1).replace(/Dict$/, '')}List`
				const actionName = `get${dict.charAt(0).toUpperCase() + dict.slice(1)}List`

				// 确保命名空间存在
				if (store.hasModule(namespace)) {
					// 异步调用加载方法
					this.$store.dispatch(`${namespace}/${actionName}`)
				} else {
					console.error(`[Vuex] 模块命名空间未找到: ${namespace}`)
				}
			}

			return value
		}
	})

	return result
}

/**
 * 预加载字典数据
 * @param {String} namespace - Vuex模块命名空间
 * @param {Array} dictionaries - 字典名称数组
 */
export function preloadDictionaries(namespace, dictionaries) {
	dictionaries.forEach(dict => {
		// 构造action名称
		const actionName = `get${dict.charAt(0).toUpperCase() + dict.slice(1)}List`
		store.dispatch(`${namespace}/${actionName}`)
	})
}
